import { Input } from '../../../shared/components/Input';
import { Select } from '../../../shared/components/Select';
import { DEPOSIT_RULE_LABELS, DEPOSIT_RULE_TYPES, type DepositRule, type DepositRuleType } from '../types';

const OPTIONS = DEPOSIT_RULE_TYPES.map((t) => ({ value: t, title: DEPOSIT_RULE_LABELS[t] }));

interface Props {
  value: DepositRule;
  onChange: (rule: DepositRule) => void;
}

/**
 * Reusable deposit-rule editor (shared by the service + package forms).
 * none = pay in full at booking; percentage = take a % deposit; full = full upfront.
 */
export function DepositRuleFields({ value, onChange }: Props) {
  const setType = (type: DepositRuleType) => {
    if (type === 'percentage') {
      onChange({ type, percentageValue: value.percentageValue ?? 30 });
    } else {
      onChange({ type });
    }
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      <Select
        label="Deposit rule"
        options={OPTIONS}
        value={value.type}
        onChange={(v) => setType(v as DepositRuleType)}
      />
      {value.type === 'percentage' && (
        <Input
          label="Deposit %"
          type="number"
          min={1}
          max={100}
          value={value.percentageValue ?? ''}
          onChange={(e) => onChange({ type: 'percentage', percentageValue: Number(e.target.value) })}
        />
      )}
    </div>
  );
}
